module.exports = __webpack_public_path__ + "img/checkmark.4930177b.svg";